module.exports = __webpack_public_path__ + "media/images/icon/next-arrow-16fbc8be636ba45061c025cfbe0e2b0a.svg";